import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recruitments');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recruitments',
template: templateSource || '',
    styles: [``],
})
export class PageRecruitmentsComponent implements OnInit {
    public loading: boolean = true;
    public recruitments: any[] = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) this.recruitments = data || [];

        this.loading = false;
        await this.service.render();
    }

    public statusClass(status: string) {
        if (status === 'CONFIRMED') return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
        if (status === 'NEEDS_ADMIN_CONFIRMATION') return 'bg-amber-50 text-amber-700 border border-amber-200';
        return 'bg-zinc-50 text-zinc-600 border border-zinc-200';
    }
}

export default PageRecruitmentsComponent;